import loader from "../assets/images/l.gif";
const Loader = ({ size = 100 }) => {
  return (
    <>
      <div
        style={{
          width: "100%",
          height: size + "vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#6F00FF",

          fontSize: "20px",
        }}
      >
        <img src={loader} alt="" />
      </div>
    </>
  );
};

export default Loader;
